import { render, staticRenderFns } from "./CertificateCard.vue?vue&type=template&id=bbb6b318&scoped=true&"
import script from "./CertificateCard.vue?vue&type=script&lang=js&"
export * from "./CertificateCard.vue?vue&type=script&lang=js&"
import style0 from "./CertificateCard.vue?vue&type=style&index=0&id=bbb6b318&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb6b318",
  null
  
)

export default component.exports